
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    PRACTICESCHEDULE_ACTION,
    STUDENT_PRACTICESCHEDULE,
    ALL_PSSHOTS,
    SELECT_SHOTTYPE,
    ADD_PRACTICESCHEDULE_SUCCESS,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Practice Schedule Actions
 */

    export const student_all_practiceschedule = (student, startdate, enddate) =>{
    
        var payload={
            "id":student,
            "startdate":startdate,
            "enddate":enddate
        }
        return (dispatch) => { 
            dispatch({ type:PRACTICESCHEDULE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpracticescheduleforapi', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                const alldetails=response.data.data[0];
                dispatch({ type:STUDENT_PRACTICESCHEDULE, payload: alldetails });
                return Promise.resolve(response.data);
            });
        
        }
    }

    export const allPSshots = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: PRACTICESCHEDULE_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getpsallshot', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_PSSHOTS, payload: alldata });
            });
        }        
    
    }


    export const select_PSshottype = (shot) =>{
    
        var payload={
            "shot":shot
        }
        return (dispatch) => { 
            dispatch({ type:PRACTICESCHEDULE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpsshotdetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                const resdata=response.data;                
                dispatch({ type:SELECT_SHOTTYPE });
                return Promise.resolve(resdata);
            });
        
        }
    }

    export const select_PSshotdrill = (shot, typeid) =>{
    
        var payload={
            "shot":shot,
            "type":typeid
        }
        return (dispatch) => { 
            dispatch({ type:PRACTICESCHEDULE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpsshottydetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                const resdata=response.data;                
                dispatch({ type:SELECT_SHOTTYPE });
                return Promise.resolve(resdata);
            });
        
        }
    }


    export const addPracticeSchedule = (psstate, student) => async (dispatch) => {
            
            var dsds=psstate.target; 
            var week=psstate.target.weekval.value;
            var day=psstate.target.dayval.value;
            var payload={
                "student":student,
                "week":week,  
                "day":day,          
            }
            
            
                
                for (let j = 1; j<=5; j++) {
                    
                    var shotadd='shot_'+week+'_'+day+'_'+j;             
                    var typeadd='type_'+week+'_'+day+'_'+j;            
                    var drilladd='drill_'+week+'_'+day+'_'+j;  
                    var eddrilladd='edpractdrill_'+week+'_'+day+'_'+j; 
                    
                    var sepday='practshot_'+week+'_'+day+'_'+j;
                    var sepopt='practtype_'+week+'_'+day+'_'+j;   
                    var septravel='practdril_'+week+'_'+day+'_'+j; 
                    var eddrill='edpractdrill_'+week+'_'+day+'_'+j;
                    
                        var shotval=psstate.target[sepday].value; 
                        var typeval=psstate.target[sepopt].value;                                    
                        var drillval=psstate.target[septravel].value;                                     
                        var eddrilval=psstate.target[eddrill].value;

                        payload[shotadd]=shotval;
                        payload[typeadd]=typeval;
                        payload[drilladd]=drillval;
                        payload[eddrilladd]=eddrilval;
                    
                }

           
            
            dispatch({ type: PRACTICESCHEDULE_ACTION});
            return axios.post(AppConfig.apiurl+'/api/addnewpracticeschedule', payload, { headers: AuthHeader.header })
                .then( response => {       
                    if(response.status==200){ 
                        var resdata=response.data;
                        if(resdata.status===1){
                            NotificationManager.success(resdata.message);               
                            dispatch({ type: ADD_PRACTICESCHEDULE_SUCCESS});
                        }
                            
                    } 
                    
                    return Promise.resolve(resdata);
                    
                })
                .catch( error => { 
                    const errormsg="Technical issue, Please try sometime later";
                    NotificationManager.error(errormsg);
               
            });		

    }

    export const addPracticeHeading = (student, week, heading) => async (dispatch) => {

        var payload={
            "student":student,
            "week":week,  
            "heading":heading,          
        }
        
        dispatch({ type: PRACTICESCHEDULE_ACTION});
        return axios.post(AppConfig.apiurl+'/api/addpracticeheading', payload, { headers: AuthHeader.header })
            .then( response => {       
                if(response.status==200){ 
                    var resdata=response.data;
                    if(resdata.status===1){
                        //NotificationManager.success(resdata.message);               
                        dispatch({ type: ADD_PRACTICESCHEDULE_SUCCESS});
                    }
                        
                } 
                
                //return Promise.resolve(resdata);
                
            })
            .catch( error => { 
                const errormsg="Technical issue, Please try sometime later";
                //NotificationManager.error(errormsg);
           
        });		

    }

    export const getPracticeHeading = (student, week) =>{
    
        var payload={
            "student":student,
            "week":week          
        }
        return (dispatch) => { 
            dispatch({ type:PRACTICESCHEDULE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpracticeheading', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                const resdata=response.data;                
                dispatch({ type:SELECT_SHOTTYPE });
                return Promise.resolve(resdata);
            });
        
        }
    }

